import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Icon, Button } from 'antd';
import styled from 'styled-components';
import CadenceDrawer from '../../components/CadenceDrawer';
import * as settingActions from '~/containers/Settings/actions';

var COLOR = '#eb2f96';

var CadenceCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: ${COLOR};
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
    transform: translateY(-1px);
  }
`;

var CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

var CardTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  display: flex;
  align-items: center;
  gap: 10px;
`;

var CardBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  background: #fff0f6;
  color: ${COLOR};
`;

var StepTimeline = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  flex-wrap: wrap;
`;

var StepDot = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background: #f5f5f5;
  color: #595959;
`;

var StepArrow = styled.span`
  color: #d9d9d9;
  font-size: 10px;
`;

var EmptyState = styled.div`
  text-align: center;
  padding: 48px 20px;
  color: #bfbfbf;
`;

var AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  color: #8c8c8c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 4px;

  &:hover {
    border-color: ${COLOR};
    color: ${COLOR};
    background: #fff0f6;
  }
`;

var SocialSelling = function(props) {
    var addTrigger = props.addTrigger || 0;
    var searchTerm = props.searchTerm || '';
    var drawerState = useState(false);
    var isDrawerVisible = drawerState[0];
    var setIsDrawerVisible = drawerState[1];
    var cadenceState = useState(null);
    var selectedCadence = cadenceState[0];
    var setSelectedCadence = cadenceState[1];
    var dispatch = useDispatch();
    var allCadences = useSelector(function(state) { return state.settings['socialSelling.cadence'] || []; });

    var prevTriggerRef = React.useRef(addTrigger);
    useEffect(function() {
        if (addTrigger > 0 && addTrigger !== prevTriggerRef.current) {
            setIsDrawerVisible(true);
            setSelectedCadence(null);
        }
        prevTriggerRef.current = addTrigger;
    }, [addTrigger]);

    var showDrawer = function(cadence) {
        setSelectedCadence(cadence || null);
        setIsDrawerVisible(true);
    };

    var handleCancel = function() {
        setIsDrawerVisible(false);
        setSelectedCadence(null);
    };

    var handleDelete = function(record, e) {
        if (e) e.stopPropagation();
        Modal.confirm({
            title: "Remover esta cadência?",
            content: "Esta ação não poderá ser desfeita.",
            okText: "Excluir", okType: "danger", cancelText: "Cancelar", zIndex: 1030,
            onOk: function() {
                dispatch(settingActions.deleteSetting({ id: record.id, key: 'socialSelling.cadence' }));
            },
        });
    };

    var filtered = allCadences.filter(function(c) {
        if (!searchTerm) return true;
        try {
            var name = JSON.parse(c.value).name || '';
            return name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0;
        } catch(e) { return true; }
    });

    return React.createElement('div', null,
        filtered.length === 0 && !searchTerm
            ? React.createElement(EmptyState, null,
                React.createElement(Icon, { type: 'share-alt', style: { fontSize: 40, marginBottom: 10, display: 'block' } }),
                React.createElement('div', { style: { fontSize: 14, marginBottom: 4 } }, 'Nenhuma cadência'),
                React.createElement('div', { style: { fontSize: 12 } }, 'Crie cadências para organizar suas etapas de social selling')
              )
            : filtered.map(function(record) {
                var parsed = {};
                try { parsed = JSON.parse(record.value); } catch(e) {}
                var name = parsed.name || '';
                var steps = parsed.data || [];

                return React.createElement(CadenceCard, {
                    key: record.id,
                    onClick: function() { showDrawer(record); }
                },
                    React.createElement(CardHeader, null,
                        React.createElement(CardTitle, null,
                            React.createElement(Icon, { type: 'share-alt', style: { color: COLOR, fontSize: 16 } }),
                            name,
                            React.createElement(CardBadge, null,
                                React.createElement(Icon, { type: 'ordered-list', style: { fontSize: 10 } }),
                                steps.length + ' etapa' + (steps.length !== 1 ? 's' : '')
                            )
                        ),
                        React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 4 }, onClick: function(e) { e.stopPropagation(); } },
                            React.createElement(Button, {
                                type: 'link', size: 'small',
                                style: { color: '#ff4d4f', fontSize: 12 },
                                onClick: function(e) { handleDelete(record, e); }
                            },
                                React.createElement(Icon, { type: 'delete' })
                            )
                        )
                    ),
                    steps.length > 0 && React.createElement(StepTimeline, null,
                        steps.map(function(step, i) {
                            var label = 'Dia ' + (step.day || '?');
                            return React.createElement(React.Fragment, { key: i },
                                i > 0 && React.createElement(StepArrow, null, '→'),
                                React.createElement(StepDot, null, label)
                            );
                        })
                    )
                );
            }),
        React.createElement(AddButton, { onClick: function() { showDrawer(null); } },
            React.createElement(Icon, { type: 'plus' }),
            'Criar Cadência'
        ),
        React.createElement(CadenceDrawer, {
            visible: isDrawerVisible,
            onClose: handleCancel,
            selectedCadence: selectedCadence,
            settingsKey: 'socialSelling.cadence',
            activityTypeField: 'input',
            color: COLOR
        })
    );
};

export default SocialSelling;
